<!--
Author: TangChen
Date: 2018-10-23
Desc: 现金宝七日年化收益率，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-currency-rate bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="xjb-rate">
            <el-col :span="11" class="xib-advan">
                <el-col :span="24">
                    <span class="intro">闲钱理财，就用现金宝</span>
                </el-col>
                <el-col :span="24">
                    <p class="text">1元起购，买卖0费用，赎回2小时到账，历史无亏损</p>
                </el-col>
                <el-col :span="8">
                    <div class="rate-icon icon1" />
                    <span class="icon-explain">一元起购</span>
                </el-col>
                <el-col :span="8">
                    <div class="rate-icon icon2" />
                    <span class="icon-explain">T+0赎回</span>
                </el-col>
                <el-col :span="8">
                    <div class="rate-icon icon3" />
                    <span class="icon-explain">业绩良好</span>
                </el-col>
            </el-col>
            <el-col :span="13" class="rate-val-con">
                <el-col :span="20">
                    <div v-if="xjbInfo.growthrate" class="rate-val">
                        <num-grow :value="xjbInfo.growthrate" />
                        <span>%</span>
                    </div>
                    <p class="rate-val-intro">近七日年化收益率</p>
                    <span class="rate-val-time">
                        万份收益：
                        <span>{{ $util.fmtNum(xjbInfo.fundincomeunit, 4) }}元</span>
                        收益统计时间：{{ xjbInfo.incomedate }}
                    </span>
                </el-col>
                <el-col :span="4">
                    <el-button
                        class="xjb-circle"
                        circle
                        :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                        v-on:click="goCurrencyCharge"
                    >
                        立即充值
                    </el-button>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import numGrow from "@/components/misc/numGrow.vue";
export default {
    name: "CurrencyRate",
    components: {
        numGrow
    },
    mixins: [mixin],
    data() {
        return {
            xjbInfo: {
                growthrate: "0"
            }
        };
    },
    created() {
        this.getXjbInfo();
    },
    methods: {
        // 获取现金宝信息
        getXjbInfo() {
            const _this = this;
            this.$util.request("xjb/query/info").then((res) => {
                if (res.data) {
                    if (res.data[0] && res.data[0][0]) {
                        _this.xjbInfo = res.data[0][0];
                    } else {
                        _this.xjbInfo = res.data[0] ? res.data[0] : {};
                    }
                }
            });
        },
        goCurrencyCharge() {
            if (this.$util.checkPersonalBuyBusinessDisabled("充值")) return;
            this.$router.push({ name: "currencycharge" });
        }
    }
};
</script>
<style lang="scss">
.bizcomp-currency-rate {
    .xjb-rate {
        height: 300px;
        background: url($xjbBg) center center no-repeat;
        .xib-advan {
            padding: 30px 0;
        }
        .el-col {
            text-align: center;
            &.rate-val-con {
                padding: 0 24px;
            }
            .intro {
                color: var(--color-primary);
                font-size: $f26;
                line-height: 40px;
            }
            .text {
                color: $text-color6;
                font-size: $f18;
                line-height: 40px;
                margin-bottom: 10px;
            }
            .rate-val {
                color: var(--color-primary);
                font-size: 140px;
                span {
                    font-size: 100px;
                }
            }
            .rate-val-intro {
                color: var(--color-primary);
                font-size: $f30;
                line-height: 40px;
            }
            .rate-val-time {
                padding: 10px 0;
                display: inline-block;
                color: $text-color6;
                font-size: $f16;
                line-height: 40px;
                span {
                    margin-right: 15px;
                    display: inline-block;
                    font-size: $f18;
                    color: var(--color-primary);
                }
            }
            .xjb-circle {
                margin-top: 97px;
                width: 100px;
                height: 100px;
                border: 2px solid var(--color-primary);
                font-size: $f18;
                color: $text-color8;
                background-color: $bg13;
            }
            .rate-icon {
                width: 98px;
                height: 98px;
                border: 2px solid var(--color-primary);
                border-radius: 100%;
                margin: 0 auto;
                &.icon1 {
                    background: url($icon) 16px -92px no-repeat;
                }
                &.icon2 {
                    background: url($icon) -84px -94px no-repeat;
                }
                &.icon3 {
                    background: url($icon) -183px -94px no-repeat;
                }
            }
            .icon-explain {
                color: var(--color-primary);
                font-size: $f18;
                line-height: 50px;
            }
        }
    }
}
</style>
